// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pagination-label>.label[data-v-8d435524]{font-size:1.4rem;font-weight:400;font-family:\"HiraKakuProN-W3\",\"Yu Gothic\",YuGothic,sans-serif}.pagination-label>.label[data-v-8d435524] .total{font-size:1.6rem;color:#2aa314}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
